import script from "./ReferencesDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./ReferencesDetail.vue?vue&type=script&lang=ts&setup=true"

import "./ReferencesDetail.vue?vue&type=style&index=0&id=155a0ed6&lang=scss"

const __exports__ = script;

export default __exports__
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSplitter from 'quasar/src/components/splitter/QSplitter.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTooltip,QBtn,QIcon,QSplitter,QToggle});
